module.exports = __webpack_public_path__ + "static/media/partner.7d76214f.jpg";